export default __webpack_public_path__ + "static/media/logoB.ef0b05ca.png";